import React from "react";
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap";
import { Table } from "antd";
import { Form } from "react-final-form";
import CheckboxField from "@/shared/components/form/CheckboxField";
const HierarchyListDigitalMediaModal = ({
  isOpen,
  toggle,
  hierarchyListData,
  checkedState,
  setCheckedState,
  onSubmitHierarchyList,
  program
}) => {
  const columns = [
    {
      title: "Program ID",
      dataIndex: "id",
      key: "id",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Program Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Copy / Update?",
      key: "action",
      render: (_, record, index) => (
        <div className="checkbox-custom2">
          <CheckboxField
            name={`action-checkbox-${record.id}`}
            label={record.media_will_be_updated ? "update" : "add"}
            checked={checkedState[index].checked}
            disabled={checkedState[index].value === program.id}
            onChange={() => {
              const updated = [...checkedState];
              updated[index].checked = !updated[index].checked;
              setCheckedState(updated);
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <Modal
      className="modal-media-hierarchy-list modal-lg"
      isOpen={isOpen}
      toggle={toggle}
    >
      <ModalHeader>
        <div>
          Please select the programs that you wish to update or add this digital media to
        </div>
      </ModalHeader>

      <ModalBody className="modal-lg" style={{ textAlign: "left" }}>
        <Form onSubmit={onSubmitHierarchyList}>
          {({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div style={{}}>
                <Button
                  outline
                  className="btn btn-primary btn-sm"
                  color="#ffffff"
                >
                  Save
                </Button>
              </div>

              <Table
                pagination={false}
                rowKey="id"
                columns={columns}
                dataSource={hierarchyListData}
              />
            </form>
          )}
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default HierarchyListDigitalMediaModal;
